import { render, staticRenderFns } from "./storeShow.vue?vue&type=template&id=6fbb93be&scoped=true"
import script from "./storeShow.vue?vue&type=script&lang=js"
export * from "./storeShow.vue?vue&type=script&lang=js"
import style0 from "./storeShow.vue?vue&type=style&index=0&id=6fbb93be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbb93be",
  null
  
)

export default component.exports